<template>
  <el-config-provider :locale="epLocale">
    <hb-config-provider
      :product-code="baseStore.getProductCode"
      :form-list-code="baseStore.getFormListCode"
      :token="token"
      :env="env"
      :language="lang"
      :headers="headers"
      :baseUrl="baseUrl"
    >
      <router-view />
      <HbDialogWrapper></HbDialogWrapper>
    </hb-config-provider>
  </el-config-provider>
  <WujieVue
    name="SettlementPayment"
    :url="url"
    :product-code="baseStore.getProductCode"
    width="0"
    height="0"
  ></WujieVue>
</template>

<script setup lang="ts">
import {
  HbDialogWrapper,
  HbConfigProvider,
} from '@hgj/storybrooke-business-tools'

import { en, zhCn, vi } from '@hgj/element-plus/es/locale'
import { getCurrentLanguage } from '@hgj/common-tools'
import { WujieVue } from '@stroybrooke-business-tools/plugins'
import { IS_GLOBAL } from '@/const/index'
import { fetchModuleStandardAdapter } from '@/api/common'
import to from 'await-to-js'
import { BillTypePage, ManifestPageType, ManifestAction } from '@/const/index'
import useManifestStore from '@/store/useManifestStore'
import useUserStore from '@/store/useUserStore.ts'
import useBaseStore from '@/store/useBaseStore'
import useTabs from '@/hooks/useTabs'
import { getAccessToken } from '@hgj/common-tools'

import {
  initializeDetail,
  createDefaultManifestModel,
} from '@/store/useManifestStore'
import * as R from 'ramda'
import { ElLoading } from '@hgj/element-plus'
import { useI18n } from 'vue-i18n'

const manifestStore = useManifestStore()
const user = useUserStore()
const baseStore = useBaseStore()
const route = useRoute()
const { addTab } = useTabs()
const { locale } = useI18n()
const headers = computed(() => {
  return {
    Language: locale.value,
  }
})
const baseUrl = computed(() => {
  return import.meta.env.VITE_API_HOST
})
const token = computed(() => {
  return user.getSessionId || getAccessToken()
})
const env = computed(() => {
  return import.meta.env.VITE_APP_ENV_MODE
})
const url = computed(() => {
  if (IS_GLOBAL) {
    return `${import.meta.env.VITE_USER_CENTER}mall-center/modules/settlement`
  } else {
    return `https://${import.meta.env.VITE_PREFIX}mall.hgj.com/modules/settlement`
  }
})

let epLocale = ref(zhCn)
const lang = getCurrentLanguage() || 'zh-CN'
const langMap: { [key: string]: any } = {
  'zh-CN': zhCn,
  vi: vi,
  en: en,
}
epLocale.value = langMap[lang || 'zh-CN']

/**
 * 标准引流数据
 */
async function handleStandardFrom() {
  const { stageId, flowId } = route.query
  if (!stageId) return
  const loadingInstance = ElLoading.service({ fullscreen: true })
  const [err, res] = await to(
    fetchModuleStandardAdapter({
      flowId: flowId as string,
      stageId: stageId as string,
    }),
  )
  loadingInstance.close()
  if (err) return ElMessage.error(err.message)
  const data = res as any
  initializeDetail(data)
  const defaultData = createDefaultManifestModel()
  const mergeData = R.mergeDeepRight(defaultData, data)

  const routeConfig = {
    name: BillTypePage.Detail,
    params: {
      id: String(Date.now()),
    },
    query: {
      pageType: ManifestPageType.DRAFT_PAGE,
      action: ManifestAction.NEW,
    },
    meta: {
      title: `tab.new`,
    },
  }

  manifestStore.detail.caatCode = user.defaultCaatCode

  addTab({
    value: mergeData,
    route: routeConfig,
  })
}
handleStandardFrom()
</script>
<style scoped></style>
